import ClientSDK from "../../App/ClientSDK"

type ApiWebinar = {
    uuid: string
    name: string
    description: string
    air_date: string
    preview_image: string
    video_url: string
  }

  type Webinar = {
    uuid: string
    name: string
    description: string
    airDate: string
    previewImage: string
    videoUrl: string
  }
  
  type Meta = {
    total_amount: number
  }
  
  type ApiWebinarData = {
    list: ApiWebinar[]
    meta: Meta
  }

  const webinarApiTransformer = (data: ApiWebinar): Webinar => ({   
    uuid: data.uuid,
    name: data.name,
    description: data.description,
    airDate: data.air_date,
    previewImage: data.preview_image,
    videoUrl: data.video_url,
  })

const baseUrl = 'backoffice/webinars?order_by=air_date:desc'

export const getWebinarList = async (languageParam: string): Promise<Webinar[]> => {
    const response = await ClientSDK.instance().get<ApiWebinarData>(baseUrl, { limit: 100, offset: 0, language: languageParam })
    const data = response.data
    return data.list.map(webinar => webinarApiTransformer(webinar))
}
